
import {collection, getDocs} from 'firebase/firestore';
import {db} from '../firebase';

import { HomeExamples } from '../globalValues';

export default async function getHomeExamples() {
    try {
        const tempList: HomeExamples[] = [];

        const haloWall = await getDocs(collection(db, "Home-Display"));

        haloWall.forEach(doc => {
            const temp = {
                id: doc.id,
                thumbnail: doc.data().thumbnail
            }
            tempList.push(temp);
        });
                
        return tempList;
    }
    catch(e) {
        console.log(e);
    }    
}

